// slices/topicCaches.ts
import { TopicsCacheKey } from '@/utils/cacheKeys'
import { createTopicCacheSlice } from '../topicCacheSlice'

export const createWorkspacePatternsSlice = createTopicCacheSlice(TopicsCacheKey.Workspace_Patterns)
export const createWorkspaceCollectionsSlice = createTopicCacheSlice(
  TopicsCacheKey.Workspace_Collections,
)
export const createWorkspacePinsSlice = createTopicCacheSlice(TopicsCacheKey.Workspace_Pins)

export const createDiscoverPatternsSlice = createTopicCacheSlice(TopicsCacheKey.Discover_Patterns)
export const createDiscoverCollectionsSlice = createTopicCacheSlice(
  TopicsCacheKey.Discover_Collections,
)
export const createDiscoverPinsSlice = createTopicCacheSlice(TopicsCacheKey.Discover_Pins)
